function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Component, forwardRef } from "react";
import { mapStyle } from "../map-style";
import { getPBDBData } from "./filter-helpers";
import h from "@macrostrat/hyper";
import "mapbox-gl/dist/mapbox-gl.css";
import { setMapStyle } from "./style-helpers";
import { MapLayer } from "~/map-interface/app-state";
var maxClusterZoom = 6;
var highlightLayers = [{
  layer: "pbdb-points",
  source: "pbdb-points"
}, {
  layer: "pbdb-points-clustered",
  source: "pbdb-points"
}, {
  layer: "pbdb-clusters",
  source: "pbdb-clusters"
}];

var VestigialMap = /*#__PURE__*/function (_Component) {
  _inherits(VestigialMap, _Component);

  var _super = _createSuper(VestigialMap);

  function VestigialMap(props) {
    var _this;

    _classCallCheck(this, VestigialMap);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "map", void 0);

    _defineProperty(_assertThisInitialized(_this), "marker", null);

    _this.mapLoaded = false;
    _this.currentSources = [];
    _this.elevationPoints = [];
    _this.maxValue = 500;
    _this.previousZoom = 0; // We need to store these for cluster querying...

    _this.pbdbPoints = {}; // Keep track of unique ids for interaction states

    _this.hoverStates = {};
    _this.selectedStates = {};
    return _this;
  }

  _createClass(VestigialMap, [{
    key: "onStyleLoad",
    value: function onStyleLoad() {
      var _this2 = this;

      // The initial draw of the layers
      // console.log("Style loaded", this.props);
      if (!this.map.style._loaded) {
        return;
      }

      var mapLayers = this.props.mapLayers;
      mapStyle.layers.forEach(function (layer) {
        // Populate the objects that track interaction states
        _this2.hoverStates[layer.id] = null;
        _this2.selectedStates[layer.id] = null; // Accomodate any URI parameters

        if (layer.source === "burwell" && layer["source-layer"] === "units" && mapLayers.has(MapLayer.BEDROCK)) {
          _this2.map.setLayoutProperty(layer.id, "visibility", "none");
        }

        if (layer.source === "burwell" && layer["source-layer"] === "lines" && mapLayers.has(MapLayer.LINES)) {
          _this2.map.setLayoutProperty(layer.id, "visibility", "none");
        }

        if ((layer.source === "pbdb" || layer.source === "pbdb-points") && mapLayers.has(MapLayer.FOSSILS)) {
          _this2.map.setLayoutProperty(layer.id, "visibility", "visible");
        }

        if (layer.source === "columns" && mapLayers.has(MapLayer.COLUMNS)) {
          _this2.map.setLayoutProperty(layer.id, "visibility", "visible");
        }
      });

      if (mapLayers.has(MapLayer.FOSSILS)) {
        this.refreshPBDB();
      } // NO idea why timeout is needed


      setTimeout(function () {
        _this2.mapLoaded = true;
      }, 1);
    }
  }, {
    key: "setupMapHandlers",
    value: function setupMapHandlers() {
      var _this3 = this;

      if (this.map != null) {
        return;
      }

      this.map = this.props.mapRef.current;

      if (this.map == null) {
        return;
      } // disable map rotation using right click + drag
      //this.map.dragRotate.disable();
      // disable map rotation using touch rotation gesture
      //this.map.touchZoomRotate.disableRotation();


      var ignoredSources = ["elevationMarker", "elevationPoints"];
      this.map.on("sourcedataloading", function (evt) {
        if (ignoredSources.includes(evt.sourceId) || _this3.props.mapIsLoading) {
          return;
        }

        _this3.props.runAction({
          type: "map-loading"
        });
      });
      this.map.on("moveend", function () {
        // Force a hit to the API to refresh
        if (_this3.props.mapLayers.has(MapLayer.FOSSILS)) {
          _this3.refreshPBDB();
        }
      });
      this.map.on("style.load", this.onStyleLoad.bind(this));
      this.onStyleLoad();
      highlightLayers.forEach(function (layer) {
        _this3.map.on("mousemove", layer.layer, function (evt) {
          if (evt.features) {
            if (_this3.hoverStates[layer.layer]) {
              _this3.map.setFeatureState({
                source: layer.source,
                id: _this3.hoverStates[layer.layer]
              }, {
                hover: false
              });
            }

            _this3.hoverStates[layer.layer] = evt.features[0].id;

            _this3.map.setFeatureState({
              source: layer.source,
              id: evt.features[0].id
            }, {
              hover: true
            });
          }
        });

        _this3.map.on("mouseleave", layer.layer, function (evt) {
          if (_this3.hoverStates[layer.layer]) {
            _this3.map.setFeatureState({
              source: layer.source,
              id: _this3.hoverStates[layer.layer]
            }, {
              hover: false
            });
          }

          _this3.hoverStates[layer.layer] = null;
        });
      });
      this.map.on("click", function (event) {
        // If the elevation drawer is open and we are awaiting to points, add them
        if (_this3.props.elevationChartOpen && _this3.props.elevationData && _this3.props.elevationData.length === 0) {
          _this3.elevationPoints.push([event.lngLat.lng, event.lngLat.lat]);

          _this3.map.getSource("elevationPoints").setData({
            type: "FeatureCollection",
            features: _this3.elevationPoints.map(function (p) {
              return {
                type: "Feature",
                geometry: {
                  type: "Point",
                  coordinates: p
                }
              };
            })
          });

          if (_this3.elevationPoints.length === 2) {
            _this3.props.runAction({
              type: "get-elevation",
              line: _this3.elevationPoints
            });

            _this3.map.getSource("elevationLine").setData({
              type: "FeatureCollection",
              features: [{
                type: "Feature",
                geometry: {
                  type: "LineString",
                  coordinates: _this3.elevationPoints
                }
              }]
            });
          }

          return;
        }

        var mapZoom = _this3.map.getZoom(); // If we are viewing fossils, prioritize clicks on those


        if (_this3.props.mapLayers.has(MapLayer.FOSSILS)) {
          var collections = _this3.map.queryRenderedFeatures(event.point, {
            layers: ["pbdb-points-clustered", "pbdb-points", "pbdb-clusters"]
          }); // Clicked on a hex grid


          if (collections.length && collections[0].properties.hasOwnProperty("hex_id")) {
            _this3.map.zoomTo(mapZoom + 1, {
              center: event.lngLat
            });

            return; // Clicked on a summary cluster
          } else if (collections.length && collections[0].properties.hasOwnProperty("oid") && collections[0].properties.oid.split(":")[0] === "clu" && mapZoom <= 12) {
            _this3.map.zoomTo(mapZoom + 2, {
              center: event.lngLat
            });

            return; // Clicked on a real cluster of collections
            // ... the way we do clustering here is kind of strange.
          } else if (collections.length && (collections[0].properties.hasOwnProperty("cluster") || // Summary cluster when zoom is too high
          collections[0].properties.oid.split(":")[0] === "clu")) {
            // via https://jsfiddle.net/aznkw784/
            var pointsInCluster = _this3.pbdbPoints.features.filter(function (f) {
              var pointPixels = _this3.map.project(f.geometry.coordinates);

              var pixelDistance = Math.sqrt(Math.pow(event.point.x - pointPixels.x, 2) + Math.pow(event.point.y - pointPixels.y, 2));
              return Math.abs(pixelDistance) <= 50;
            }).map(function (f) {
              return f.properties.oid.replace("col:", "");
            });

            _this3.props.runAction({
              type: "get-pbdb",
              collection_nos: pointsInCluster
            }); // Clicked on an unclustered point

          } else if (collections.length && collections[0].properties.hasOwnProperty("oid")) {
            var collection_nos = collections.map(function (col) {
              return col.properties.oid.replace("col:", "");
            });

            _this3.props.runAction({
              type: "get-pbdb",
              collection_nos: collection_nos
            }); //    return

          } else {
            // Otherwise make sure that old fossil collections aren't visible
            _this3.props.runAction({
              type: "reset-pbdb"
            });
          }
        } // Otherwise try to query the geologic map


        var features = _this3.map.queryRenderedFeatures(event.point, {
          layers: ["burwell_fill", "column_fill", "filtered_column_fill"]
        });

        var burwellFeatures = features.filter(function (f) {
          if (f.layer.id === "burwell_fill") return f;
        }).map(function (f) {
          return f.properties;
        });
        var columns = features.filter(function (f) {
          if (f.layer.id === "column_fill" || f.layer.id === "filtered_column_fill") return f;
        }).map(function (f) {
          return f.properties;
        });

        _this3.props.onQueryMap(event, columns);
      }); // Fired after 'swapBasemap'

      this.map.on("style.load", function () {
        if (!_this3.currentSources.length) {
          return;
        }

        _this3.currentSources.forEach(function (source) {
          if (_this3.map.getSource(source.id) == null) {
            _this3.map.addSource(source.id, source.config);
          }

          if (source.data) {
            _this3.map.getSource(source.id).setData(source.data);
          }
        }); // Readd all the previous layers to the map


        _this3.currentLayers.forEach(function (layer) {
          if (layer.filters) {
            _this3.map.setFilter(layer.layer.id, layer.filters);
          }
        });

        setMapStyle(_this3, _this3.map, mapStyle, _this3.props);
      });
    } // Handle updates to the state of the map
    // Since react isn't in charge of updating the map state we use shouldComponentUpdate
    // and always return `false` to prevent DOM updates
    // We basically intercept the changes, handle them, and tell React to ignore them

  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var _this4 = this;

      this.setupMapHandlers();
      if (this.map == null) return false;
      setMapStyle(this, this.map, mapStyle, nextProps);

      if (nextProps.mapIsRotated !== this.props.mapIsRotated) {
        return true;
      } // Watch the state of the application and adjust the map accordingly


      if (!nextProps.elevationChartOpen && this.props.elevationChartOpen && this.map) {
        this.elevationPoints = [];
        this.map.getSource("elevationPoints").setData({
          type: "FeatureCollection",
          features: []
        });
        this.map.getSource("elevationLine").setData({
          type: "FeatureCollection",
          features: []
        });
      } // Bedrock


      if (JSON.stringify(nextProps.mapCenter) != JSON.stringify(this.props.mapCenter)) {
        if (nextProps.mapCenter.type === "place") {
          var _nextProps$mapCenter$ = nextProps.mapCenter.place,
              bbox = _nextProps$mapCenter$.bbox,
              center = _nextProps$mapCenter$.center;

          if ((bbox === null || bbox === void 0 ? void 0 : bbox.length) == 4) {
            var bounds = [[nextProps.mapCenter.place.bbox[0], nextProps.mapCenter.place.bbox[1]], [nextProps.mapCenter.place.bbox[2], nextProps.mapCenter.place.bbox[3]]];
            this.map.fitBounds(bounds, {
              duration: 0,
              maxZoom: 16
            });
          } else {
            var _nextProps$mapPositio, _nextProps$mapPositio2, _nextProps$mapPositio3, _nextProps$mapPositio4;

            this.map.flyTo({
              center: center,
              duration: 0,
              zoom: Math.max((_nextProps$mapPositio = (_nextProps$mapPositio2 = nextProps.mapPosition) === null || _nextProps$mapPositio2 === void 0 ? void 0 : (_nextProps$mapPositio3 = _nextProps$mapPositio2.camera) === null || _nextProps$mapPositio3 === void 0 ? void 0 : (_nextProps$mapPositio4 = _nextProps$mapPositio3.target) === null || _nextProps$mapPositio4 === void 0 ? void 0 : _nextProps$mapPositio4.zoom) !== null && _nextProps$mapPositio !== void 0 ? _nextProps$mapPositio : 10, 14)
            });
          }
        } else {// zoom to user location
        }
      } // Handle changes to map filters


      if (nextProps.filters != this.props.filters) {
        // If all filters have been removed simply reset the filter states
        if (nextProps.filters.length === 0) {
          // Remove filtered columns and add unfiltered columns
          if (this.props.mapLayers.has(MapLayer.COLUMNS)) {
            mapStyle.layers.forEach(function (layer) {
              if (layer.source === "columns") {
                _this4.map.setLayoutProperty(layer.id, "visibility", "visible");
              }
            });
            mapStyle.layers.forEach(function (layer) {
              if (layer.source === "filteredColumns") {
                _this4.map.setLayoutProperty(layer.id, "visibility", "none");
              }
            });
          }

          if (nextProps.mapLayers.has(MapLayer.FOSSILS)) {
            this.refreshPBDB();
          }

          return false;
        }

        if (nextProps.mapLayers.has(MapLayer.FOSSILS)) {
          this.refreshPBDB();
        } // Update the map styles


        return false;
      }

      return false;
    } // PBDB hexgrids and points are refreshed on every map move

  }, {
    key: "refreshPBDB",
    value: function () {
      var _refreshPBDB = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var bounds, zoom, maxClusterZoom;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                bounds = this.map.getBounds();
                zoom = this.map.getZoom();
                maxClusterZoom = 7;
                _context.next = 5;
                return getPBDBData(this.props.filters, bounds, zoom, maxClusterZoom);

              case 5:
                this.pbdbPoints = _context.sent;

                // Show or hide the proper PBDB layers
                if (zoom < maxClusterZoom) {
                  this.map.getSource("pbdb-clusters").setData(this.pbdbPoints);
                  this.map.setLayoutProperty("pbdb-clusters", "visibility", "visible");
                  this.map.setLayoutProperty("pbdb-points-clustered", "visibility", "none"); //  map.map.setLayoutProperty('pbdb-point-cluster-count', 'visibility', 'none')

                  this.map.setLayoutProperty("pbdb-points", "visibility", "none");
                } else {
                  this.map.getSource("pbdb-points").setData(this.pbdbPoints); //map.map.getSource("pbdb-clusters").setData(map.pbdbPoints);

                  this.map.setLayoutProperty("pbdb-clusters", "visibility", "none");
                  this.map.setLayoutProperty("pbdb-points-clustered", "visibility", "visible"); //    map.map.setLayoutProperty('pbdb-point-cluster-count', 'visibility', 'visible')
                  // map.map.setLayoutProperty("pbdb-points", "visibility", "visible");
                }

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function refreshPBDB() {
        return _refreshPBDB.apply(this, arguments);
      }

      return refreshPBDB;
    }() // Update the colors of the hexgrids

  }, {
    key: "updateColors",
    value: function updateColors(data) {
      for (var i = 0; i < data.length; i++) {
        this.map.setFeatureState({
          source: "pbdb",
          sourceLayer: "hexgrid",
          id: data[i].hex_id
        }, {
          color: this.colorScale(parseInt(data[i].count))
        });
      }
    }
  }, {
    key: "colorScale",
    value: function colorScale(val) {
      var mid = this.maxValue / 2; // Max

      if (Math.abs(val - this.maxValue) <= Math.abs(val - mid)) {
        return "#2171b5"; // Mid
      } else if (Math.abs(val - mid) <= Math.abs(val - 1)) {
        return "#6baed6"; // Min
      } else {
        return "#bdd7e7";
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return VestigialMap;
}(Component);

export default /*#__PURE__*/forwardRef(function (props, ref) {
  return h(VestigialMap, _objectSpread(_objectSpread({}, props), {}, {
    elementRef: ref
  }));
});